import WorkScheduleTilesPanel, {
  WorkScheduleLink,
} from "../../components/Dashboard/Tiles/WorkScheduleTiles/WorkScheduleTiles";
import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import { useCustomerKey } from "../../utils/customHooks/useCustomerKey";
import { StyledSpinner } from "pages/CustomerTilesPage/CustomerTilesPage";
import { getCkeyFromWindow } from "constants/constants";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

/** page for selecting which work schedule you'd like to view;
 * comes after CustomerTilesPage and before DashboardPage */
const WorkSchedulesPage = () => {
  const [workScheduleConfigList] = useWorkScheduleConfigJsonListAtom();
  const [
    {
      general: { workSchedulesSortOrder },
    },
  ] = useFlightConfig();
  const ckey = useCustomerKey() ?? getCkeyFromWindow();
  if (!ckey || workScheduleConfigList.length === 0) {
    return <StyledSpinner className="WorkScheduleTilesPage-spinner" />;
  }

  const workSchedulesTiles = workScheduleConfigList
    .sort(
      (a, b) =>
        workSchedulesSortOrder.findIndex(id => id === a.id) -
        workSchedulesSortOrder.findIndex(id => id === b.id)
    )
    .reduce((prev, curr) => {
      const workSchedule = {
        name: curr.name,
        rollupShortName: curr.name,
        link: "/" + ckey,
        linkParams: ["workSchedule=" + curr.id],
        timeZone: curr.timeZone,
        id: curr.id,
      };
      return [...prev, workSchedule]; // add the work schedule to the end of the list
    }, [] as WorkScheduleLink[]); // start with an empty list

  return (
    <WorkScheduleTilesPanel {...{ workScheduleList: workSchedulesTiles }} />
  );
};

export default WorkSchedulesPage;
